var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title: _vm.isEdit
          ? _vm.$t("product-manager::prop::edit_button")
          : _vm.$t("product-manager::prop::add_button"),
        visible: _vm.dialogVisible,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "propForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.propForm,
            rules: _vm.rules,
            "label-position": "top",
            "label-width": "100px",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { staticClass: "mb-0", attrs: { label: "", "label-width": "0" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.isEdit },
                  model: {
                    value: _vm.propForm.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.propForm, "type", $$v)
                    },
                    expression: "propForm.type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("product-manager::prop::custom_prop"))
                    ),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("product-manager::prop::trigger_prop"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "dark", placement: "top" },
                },
                [
                  _c("span", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      _vm._s(_vm.$t("product-manager::prop::tooltip_prop"))
                    ),
                  ]),
                  _c("i", { staticClass: "icon-a-01wenhao iconfont-el" }),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("product-manager::prop::prop_name"),
                prop: "name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("product-manager::prop::prop_name"),
                },
                model: {
                  value: _vm.propForm.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.propForm,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "propForm.name",
                },
              }),
            ],
            1
          ),
          _vm.propForm.type === 2
            ? _c(
                "div",
                { staticStyle: { position: "relative" } },
                [
                  _c("span", { staticStyle: { "line-height": "40px" } }, [
                    _vm._v("属性值："),
                  ]),
                  [
                    _c(
                      "div",
                      { staticClass: "item-content" },
                      _vm._l(_vm.propForm.values, function (item, index) {
                        return _c(
                          "el-form-item",
                          {
                            key: item.key,
                            attrs: {
                              prop: "values." + index + ".value",
                              rules: {
                                required: true,
                                message:
                                  "" +
                                  _vm.$t(
                                    "product-manager::prop_value::placeholder_name"
                                  ),
                                trigger: "blur",
                              },
                              label: "",
                              "label-width": "0px",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "product-manager::prop::table_prop"
                                    ),
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function ($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value",
                                  },
                                }),
                                _c("i", {
                                  staticClass: "add-btn",
                                  class:
                                    index === 0
                                      ? "el-icon-plus"
                                      : "el-icon-minus",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handle(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "footer_class",
          staticStyle: { "text-align": "center", display: "block" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveSuccess } },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }